import {Injectable, Inject} from '@angular/core';
import { TRANSLATIONS } from './translations'; // import our opaque token
import { getCookie } from 'app/lib/lib';


@Injectable()
export class TranslateService {
	private _currentLang: string = 'ru';
	
	public get currentLang() {
		return this._currentLang;
	}
	
	// inject our translations
	constructor(@Inject(TRANSLATIONS) private _translations: any) {
		this.use(getCookie('i18n') || 'ru');
	}
	
	
	public use(lang: string): void {
		this._currentLang = lang;
	}
	
	
	private translate(key: string, ...params): string {
		let translation = key,
			me = this;
		
		let i18n = me._translations[me.currentLang];
		if (i18n) {
			const levels = key.split('.');
			
			while(levels.length > 0 && i18n) {
				i18n = i18n[levels.shift()];
			}
			
			if ( ! i18n) {
				//console.log(`i18n for path "${key}" not found!`);
				
				return key;
			}
			
			// Заменяем %1, %2 и т.д. на переданные значения из второго параметра вызова:
			// instant('какой-то текст %1, %2, %3', [123, '456', new Date()])
			return i18n.replace(/%\d/g, () => params.shift());
		}
		
		return translation;
	}
	
	public instant(key: string, ...params) {
		return this.translate(key, ...params);
	}
	
	
	public __(key, ...params) {
		return this.instant(key, ...params);
	}
	
	
	public __A(key, ...params) {
		return this.instant(`adminstat.${key}`, ...params);
	}
}
